require("core-js/modules/es.promise.finally");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var createWorker = require('./createWorker');

var recognize = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(image, langs, options) {
    var worker;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            worker = createWorker(options);
            _context2.next = 3;
            return worker.load();

          case 3:
            _context2.next = 5;
            return worker.loadLanguage(langs);

          case 5:
            _context2.next = 7;
            return worker.initialize(langs);

          case 7:
            return _context2.abrupt("return", worker.recognize(image).finally( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return worker.terminate();

                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }))));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function recognize(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var detect = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(image, options) {
    var worker;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            worker = createWorker(options);
            _context4.next = 3;
            return worker.load();

          case 3:
            _context4.next = 5;
            return worker.loadLanguage('osd');

          case 5:
            _context4.next = 7;
            return worker.initialize('osd');

          case 7:
            return _context4.abrupt("return", worker.detect(image).finally( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return worker.terminate();

                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            }))));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function detect(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();

module.exports = {
  recognize: recognize,
  detect: detect
};